// extracted by mini-css-extract-plugin
module.exports = {"inputBorderColor":"style_inputBorderColor__ecPwg","inputError":"style_inputError___v3gi"};